import { useEffect } from 'react';

// Color de la barra de estado cuando ninguna pantalla pide otro: el del header
// del home. Mismo valor que el <meta name="theme-color"> de index.html y el
// theme_color del manifest.
const DEFAULT_THEME_COLOR = '--color-statusbar';

// Acepta un hex ('#047E43') o el nombre de un token de index.css
// ('--color-statusbar'): así el color de la barra sale de la misma paleta que
// la pantalla y no se queda desfasado si el token cambia.
const resolver = (color) =>
  color.startsWith('--')
    ? getComputedStyle(document.documentElement).getPropertyValue(color).trim()
    : color;

// Pantallas montadas que pidieron color, en orden: manda la última. Con una
// pila (y no "guardar el anterior y restaurarlo") el color correcto vuelve
// aunque las pantallas se desmonten en otro orden.
const pedidos = [];
// Mientras el splash está encima, la barra lleva su color aunque el home (que
// ya está montado debajo) pida el suyo.
let colorSplash = null;

const pintar = () => {
  const meta = document.querySelector('meta[name="theme-color"]');
  if (!meta) return;
  const ultimo = pedidos[pedidos.length - 1];
  meta.setAttribute('content', colorSplash || (ultimo ? resolver(ultimo.color) : resolver(DEFAULT_THEME_COLOR)));
};

// Lo usa el splash: con un color, la barra lo lleva encima de todo; con null,
// vuelve al de la pantalla de abajo.
export const fijarColorSplash = (color) => {
  colorSplash = color || null;
  pintar();
};

/**
 * Cambia el `<meta name="theme-color">` mientras la pantalla está montada.
 * En Android PWA (display: standalone) esto pinta el status bar del color
 * pasado — así cada pantalla puede hacer que la barra se funda con su header
 * y la app se vea nativa, llegando hasta arriba.
 *
 * Al desmontar vuelve al color de la pantalla que quede (o al de por defecto).
 *
 * @param {string} color - hex o token CSS. Si es null/undefined, no cambia nada.
 */
export function useThemeColor(color) {
  useEffect(() => {
    if (!color) return;
    const pedido = { color };
    pedidos.push(pedido);
    pintar();
    return () => {
      pedidos.splice(pedidos.indexOf(pedido), 1);
      pintar();
    };
  }, [color]);
}

export default useThemeColor;
